import React, { useState } from "react";
import './paaas.css';

const Paaas = ({ titulo }) => {
  const [isPaaasCollapsed, setIsPaaasCollapsed] = useState(true);
  const [subMenu1Collapsed, setSubMenu1Collapsed] = useState(true);
  const [subMenu2Collapsed, setSubMenu2Collapsed] = useState(true);
  const [subMenu3Collapsed, setSubMenu3Collapsed] = useState(true);
  const [subMenu4Collapsed, setSubMenu4Collapsed] = useState(true);
  const [subMenu5Collapsed, setSubMenu5Collapsed] = useState(true);
  const [subMenu6Collapsed, setSubMenu6Collapsed] = useState(true);
  return (
    <div className="container container-mh">
      <div className="row">
        <div className="titlesecundario">
          <h1>Programa Anual de Adquisiciones, Arrendamientos y Servicios</h1>
          <hr className="hr-gob" />
          <div className="row">
              <div className="contenido-button-group">
                <button 
                  className="btn btn-primary contenido-button"
                  type="button"
                  onClick={() => setIsPaaasCollapsed(!isPaaasCollapsed)}
                  aria-expanded={!isPaaasCollapsed}
                >
                  PAAAS
                </button>
                <p></p>
                  <div className={`multi-collapse collapse ${isPaaasCollapsed ? '' : 'show'}`} id="paaas-menu">
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu1Collapsed(!subMenu1Collapsed)}
                    aria-expanded={!subMenu1Collapsed}
                  >
                    1.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2019
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu1Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="../assets/PDF/PAAAS2019.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.1 Consulta PAAAS 2019
                    </a>
                  </div>
                  <p></p>
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu2Collapsed(!subMenu2Collapsed)}
                    aria-expanded={!subMenu2Collapsed}
                  >
                    2.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2020
                  </button>
                 <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu2Collapsed ? '' : 'show'}`} id="lista-0-1">
                    <a
                      href="../assets/PDF/PAAAS2020.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      2.1 Consulta PAAAS 2020
                    </a>
                  </div>
                  <p></p>
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu3Collapsed(!subMenu3Collapsed)}
                    aria-expanded={!subMenu3Collapsed}
                  >
                    3.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2021
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu3Collapsed ? '' : 'show'}`} id="lista-0-2">
                    <a
                      href="../assets/PDF/PAAAS2021.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado" 
                    >
                      3.1 Consulta PAAAS 2021
                    </a>
                  </div>
                  <p></p>
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu4Collapsed(!subMenu4Collapsed)}
                    aria-expanded={!subMenu4Collapsed}
                  >
                    4.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2023
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu4Collapsed ? '' : 'show'}`} id="lista-0-3">
                    <a
                      href="../assets/PDF/PAAAS2023.pdf"
                      target="_blank"
                      className="btn btn-primary btn-armo-collapse btn-dorado" 
                    >
                      4.1 Consulta PAAAS 2023
                    </a>
                    </div>
                  <p></p>
                    <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu5Collapsed(!subMenu5Collapsed)}
                    aria-expanded={!subMenu5Collapsed}
                  >
                    5.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2024
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu5Collapsed ? '' : 'show'}`} id="lista-0-4">
                    <a
                      href="https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/PAAAS.pdf"
                      target="_blank"rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado" 
                    >
                      5.1 Consulta PAAAS 2024
                    </a>
                  </div>
                  <p></p>
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu6Collapsed(!subMenu6Collapsed)}
                    aria-expanded={!subMenu6Collapsed}
                  >
                    6.- Programa Anual de Adquisiciones, Arrendamientos y Servicios 2026
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu6Collapsed ? '' : 'show'}`} id="lista-0-5">
                    <a
                      href="https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/PAAAS2026.pdf"
                      target="_blank" rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado" 
                    >
                      6.1 Consulta PAAAS 2026
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
};

export default Paaas;
